import { CircularProgress } from "@material-ui/core";
import React from "react";

import useStyles from "./useStyles";

/**
 * ProgressViewコンポーネント.
 *
 * @return {object} コンポーネント
 */
function ProgressView() {
  // スタイル
  const styles = useStyles();

  return (
    <div className={styles.progressView}>
      <CircularProgress color="primary" size={40} />
    </div>
  );
}

export default ProgressView;
